import { Box, Skeleton, SxProps, Theme } from '@mui/material';
import { ReactNode } from 'react';

/**
 * Horizontal padding aligned with fragment/composition grid card footers
 * (`FRAGMENT_CARD_PADDING_X`). Kept here so base app-card does not import from modules.
 */
const APP_CARD_SKELETON_FOOTER_PADDING_X = { xs: 1, md: 1.5, xl: 2 };

interface AppCardSkeletonMetaFooterProps {
  /** Optional trailing control (e.g. edits-count chip placeholder). */
  endAdornment?: ReactNode;
  sx?: SxProps<Theme>;
}

/**
 * Common footer for list-card skeletons: two short meta bars, optional trailing chip/control.
 */
export function AppCardSkeletonMetaFooter({ endAdornment, sx }: AppCardSkeletonMetaFooterProps) {
  const metaBars = (
    <>
      <Skeleton width={80} height={20} />
      <Skeleton width={60} height={20} />
    </>
  );

  return (
    <Box
      sx={{
        px: APP_CARD_SKELETON_FOOTER_PADDING_X,
        pb: 1.5,
        display: 'flex',
        alignItems: 'center',
        gap: endAdornment ? 0.5 : 1,
        ...sx,
      }}
    >
      {endAdornment ? (
        <>
          <Box sx={{ flex: 1, minWidth: 0, display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
            {metaBars}
          </Box>
          {endAdornment}
        </>
      ) : (
        metaBars
      )}
    </Box>
  );
}
